import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import AppSidebar from "../../components/AppSidebar";
import RecentActivity from "../../components/RecentActivity";
import LogsTable from "../../components/LogsTable";
import AppHeader from "../../components/AppHeader";
import PageHeader from "../../components/PageHeader";
import FeedbackService from "../../services/FeedbackService";
import CallLogService from "../../services/CallLogService";
import CallLog from "../../modals/CallLog";
import { useForm } from 'react-hook-form';
import { toast, ToastContainer } from "react-toastify";


const ViewFeedback = () => {
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const { id } = useParams();
    const type = "feedback";
    const [feedback, setFeedback] = useState(null);
    const [allCallLogs, setAllCallLogs] = useState([]);
    const [showCallLogModal, setShowCallLogModal] = useState(false);
    const [statusData, setStatusData] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');
    const today = new Date().toISOString().split('T')[0];
    const callLogForm = useForm();
    const [callLogData, setCallLogData] = useState({});

    const fetchFeedback = useCallback(async () => {
        try {
            const response = await FeedbackService.get(id);
            if (response.status === 200) {
                setFeedback(response?.data?.data);
            }
        } catch (error) {
            console.error("Error fetching feedback:", error);
        }
    }, [id]);

    useEffect(() => {
        fetchFeedback();
    }, [fetchFeedback]);

    const fetchCallLogs = useCallback(async () => {
        try {
            const response = await CallLogService.getLogByType(type, id);
            if (response.status === 200) {
                setAllCallLogs(response?.data?.data || []);
            } else {
                console.error('Error fetching data:', response);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }, [id]);

    useEffect(() => {
        fetchCallLogs();
    }, [fetchCallLogs]);

    const openCallLogModal = () => setShowCallLogModal(true);

    const handleClose = () => setShowCallLogModal(false);
    const onCallLogSubmit = async (data) => {
        try {
            const requestData = {
                type: "feedbacks",
                type_id: parseInt(id) || 0,
                status: data?.status || '',
                feedback_type: data?.feedback_type || "negative",
                response: data?.response || "not_interested",
                remarks: data?.remarks || "NA",
                rescheduled_at: data.date || null,
            }

            const response = await CallLogService.createLog({ data: requestData });
            if (response.status === 201) {
                toast.success(response?.data?.message);
                setAllCallLogs(prevLogs => [...prevLogs, response.data.data]);
                setShowCallLogModal(false);
                reset();
            } else {
                toast.error(response?.data?.message);
            }
        } catch (error) {
            toast.error(error?.message || "An error occurred");
        }
    };
    const handleCallLog = (e) => {
        const value = e.target.value;
        setSelectedStatus(value);
        setCallLogData(prevState => ({ ...prevState, status: value }));
        if (value === 'connected' || value === 'disconnected') {
            setStatusData(
                <div>
                    <form onSubmit={handleSubmit(onCallLogSubmit)}>
                        <div className="form-group">
                            <label htmlFor="rescheduleDate" className="form-label">Reschedule Date & Time</label>
                            <input
                                type="date"
                                className="form-control mb-2"
                                id="rescheduleDate"
                                {...register('date', { required: 'Date is required' })}
                                onChange={(e) => setCallLogData({ ...callLogData, date: e.target.value })}
                            />
                            {errors.date && <p className="text-danger">{errors.date.message}</p>}
                        </div>
                        <div className="form-group mt-3">
                            <textarea
                                className="form-control"
                                id="callRemark"
                                rows="2"
                                placeholder="Call Remark"
                                {...register('remarks', { required: 'Remark is required' })}
                                onChange={(e) => setCallLogData({ ...callLogData, remarks: e.target.value })}
                            ></textarea>
                            {errors.remarks && <p className="text-danger">{errors.remarks.message}</p>}
                        </div>
                        {value === 'connected' && (
                            <div className="form-group mt-3">
                                <select
                                    className="form-select"
                                    {...register('feedback_type', { required: 'Feedback type is required' })}
                                    onChange={(e) => setCallLogData({ ...callLogData, feedback_type: e.target.value })}
                                >
                                    <option value="">Select Feedback Type</option>
                                    <option value="positive">Positive</option>
                                    <option value="negative">Negative</option>
                                </select>
                                {errors.feedback_type && <p className="text-danger">{errors.feedback_type.message}</p>}
                            </div>
                        )}
                        <div className="form-group mt-3">
                            <select
                                className="form-select"
                                {...register('response', { required: 'response type is required' })}
                                onChange={(e) => setCallLogData({ ...callLogData, response: e.target.value })}
                            >
                                <option value="">Select Response Type</option>
                                <option value="interested">Interested</option>
                                <option value="not_interested">Not Interested</option>
                            </select>
                            {errors.feedback_type && <p className="text-danger">{errors.feedback_type.message}</p>}
                        </div>
                    </form>
                </div>
            );
        } else {
            setStatusData(null);
        }
    };
    return (
        <>
            <AppSidebar />
            <div className="main-content">
                <AppHeader title="Feedback" />
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <PageHeader
                                title="View Feedback"
                                button_label="Back"
                                link_to="/feedbacks"
                                className="btn btn-sm btn-primary me-2"
                                button_label1="Log a Call"
                                buttonAttributes1={{ onClick: openCallLogModal }}
                                className1="btn btn-sm btn-info"
                            />
                        </div>
                        <div className="col-12 col-md-8 mb-4">
                            <div className="card p-4">
                                <div className="form-group d-flex justify-content-between mb-3">
                                    <label className="form-label">Name:</label>
                                    <span>
                                        {`${feedback?.employee?.first_name || ""} ${feedback?.employee?.last_name || ""}`.trim() || "N/A"}
                                    </span>
                                </div>
                                <div className="form-group d-flex justify-content-between mb-3">
                                    <label className="form-label">Email:</label>
                                    <span>{feedback?.employee?.email || "N/A"}</span>
                                </div>
                                <div className="form-group d-flex justify-content-between mb-3">
                                    <label className="form-label">Ratings:</label>
                                    <span>{feedback?.rating || "N/A"}</span>
                                </div>
                                <div className="form-group d-flex justify-content-between mb-3">
                                    <label className="form-label">Customer:</label>
                                    <span>{feedback?.employee?.customer?.company || "N/A"}</span>
                                </div>
                                <div className="form-group d-flex justify-content-between mb-3">
                                    <label className="form-label">Product:</label>
                                    <span>{feedback?.product?.name || "N/A"}</span>
                                </div>
                                <div className="form-group d-flex justify-content-between mb-3">
                                    <label className="form-label">Feedback Link:</label>
                                    <span className="text-primary w-50">{feedback?.feedbackLink?.link || "N/A"}</span>
                                </div>
                                <div className="form-group d-flex justify-content-between mb-3">
                                    <label className="form-label">Feedback:</label>
                                    <span>{feedback?.feedback || "N/A"}</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4 mb-4">
                            <RecentActivity type={type} />
                        </div>
                        <LogsTable allCallLogs={allCallLogs} />
                    </div>
                </div>
            </div>
            {showCallLogModal && (
                <CallLog
                    show={showCallLogModal}
                    handleClose={handleClose}
                    handleSubmit={callLogForm.handleSubmit}
                    onSubmit={onCallLogSubmit}
                    register={callLogForm.register}
                    errors={callLogForm.formState.errors}
                    selectedStatus={selectedStatus}
                    handleCallLog={handleCallLog}
                    statusData={statusData}
                    reset={reset}
                    today={today}
                />
            )}
            <ToastContainer />
        </>
    );
};

export default ViewFeedback;
